export default __webpack_public_path__ + "alberta-fab-additional-order.65e4afc6165e2d2aeace.svg";